<template>
    <form-item-wrapper :widget="widget" ref="itemref">
        <a-button :type="widget.options.type" :shape="widget.options.shape" :loading="widget.options.loading"
            :ghost="widget.options.ghost" :danger="widget.options.danger" :disabled="widget.options.disabled"
            :block="widget.options.block" @click="handleOnClick">
            <template v-if="widget.options.icon" #icon>
                <component :is="widget.options.icon" />
            </template>
            {{ widget.label }}
        </a-button>
    </form-item-wrapper>
</template>

<script setup>
import FormItemWrapper from "./form-item-wrapper.vue";
import { ref, toRefs } from 'vue';
import useEvent from "./useEvent";

const props = defineProps({
    widget: Object,
    formData: Object,
})
const { widget, formData } = toRefs(props)
const itemref = ref(null)

const {
    handleOnClick,
} = useEvent(widget.value, itemref, formData.value);
</script>